import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad.js';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage.js';

function SubAdminReferenceUnitRate(props) {
    const [datalist, setDatalist] = useState([]);

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    useEffect(() => {
        api_load()
    }, []);

    useEffect(() => {
        return () => {
            setDatalist([])
        };
    }, []);

    async function api_load() {
        setmodal_load({ enable: true, message: "Loading unit rate list." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/reference/refunitrate/getlist", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {

                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
                if (response.data.unitrate !== null && response.data.unitrate !== undefined) {
                    setDatalist(response.data.unitrate)
                } else {
                    setDatalist([])
                }
            })
            .catch((err) => {
                setDatalist([])
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }
    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-calendar-alt"></i> Unit Rate</h4>
                                    <p className="mb-0">Manage all parameter of unit rate</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" onClick={() => { api_load() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-3 mb-1 mb-md-4">
                        <h5 className='mt-3'>Unit Rate Table</h5>
                        <div className="table-responsive">
                            <table className="table table-striped table-bordered text-nowrap" >
                                <thead>
                                    <tr className="admintable-header">
                                        <th style={{ width: "110px" }} rowSpan={2}>Year</th>
                                        <th colSpan={2} className='text-center'>January</th>
                                        <th colSpan={2} className='text-center'>February</th>
                                        <th colSpan={2} className='text-center'>March</th>
                                        <th colSpan={2} className='text-center'>April</th>
                                        <th colSpan={2} className='text-center'>May</th>
                                        <th colSpan={2} className='text-center'>June</th>
                                        <th colSpan={2} className='text-center'>July</th>
                                        <th colSpan={2} className='text-center'>August</th>
                                        <th colSpan={2} className='text-center'>September</th>
                                        <th colSpan={2} className='text-center'>October</th>
                                        <th colSpan={2} className='text-center'>November</th>
                                        <th colSpan={2} className='text-center'>December</th>
                                        <th rowSpan={2}>Edit Time</th>
                                    </tr>
                                    <tr className="admintable-header">
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center' >Off-p</th>
                                        <th className='text-center'>On-p</th>
                                        <th className='text-center'>Off-p</th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {
                                        datalist?.map((data, index) => (
                                            <tr key={data.year}>
                                                <td><i className="fas fa-calendar-alt rows-icon"></i> {data.year}</td>
                                                <td className='text-center'>{data.m1_onpeak > 0 ? data.m1_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m1_offpeak > 0 ? data.m1_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m2_onpeak > 0 ? data.m2_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m2_offpeak > 0 ? data.m2_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m3_onpeak > 0 ? data.m3_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m3_offpeak > 0 ? data.m3_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m4_onpeak > 0 ? data.m4_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m4_offpeak > 0 ? data.m4_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m5_onpeak > 0 ? data.m5_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m5_offpeak > 0 ? data.m5_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m6_onpeak > 0 ? data.m6_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m6_offpeak > 0 ? data.m6_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m7_onpeak > 0 ? data.m7_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m7_offpeak > 0 ? data.m7_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m8_onpeak > 0 ? data.m8_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m8_offpeak > 0 ? data.m8_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m9_onpeak > 0 ? data.m9_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m9_offpeak > 0 ? data.m9_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m10_onpeak > 0 ? data.m10_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m10_offpeak > 0 ? data.m10_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m11_onpeak > 0 ? data.m11_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m11_offpeak > 0 ? data.m11_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m12_onpeak > 0 ? data.m12_onpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.m12_offpeak > 0 ? data.m12_offpeak.toLocaleString('en-US', { minimumFractionDigits: 4, maximumFractionDigits: 4 }) : "-"}</td>
                                                <td className='text-center'>{data.edittime !== "-" ? data.edittime : "-"}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminReferenceUnitRate